import React from 'react';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { getComponentClasses } from '@99designs/frontend-components/utils/app';

// import './_star-rating.scss';

interface Props {
    rating: number;
    color?: string;
    variations?: string[];
}

export default function StarRating({ rating, color, variations }: Props) {
    const className = getComponentClasses('star-rating', variations);

    return (
        <div
            className={className}
            aria-label={formatMessage(__('Rating: {rating} out of 5 stars'), {
                rating,
            })}
            role="img"
        >
            {[1, 2, 3, 4, 5].map((starIndex: number) => {
                let width;
                if (starIndex <= rating) {
                    width = 100;
                } else if (starIndex - rating > 1) {
                    width = 0;
                } else {
                    width = (1 - (starIndex - rating)) * 100;
                }

                return (
                    <div className="star-rating__star" key={starIndex}>
                        <span
                            style={{ width: `${width}%`, color: color }}
                            className="star-rating__star__icon"
                            data-testid={'star-rating'}
                        />
                    </div>
                );
            })}
        </div>
    );
}
